module.exports = __webpack_public_path__ + "images/932e82ef072c7df18e91e66b96dfdf5d.svg";